// axiosInstance.js
import axios from 'axios';
import Qs from 'qs';
import envBaseURL from './config/localhost.js';
import { useToast } from "vue-toastification";

import pinia from "stores";
const toast = useToast();
import { useAuthenticationStore } from 'stores/authenticationStore'
const authenticationStore = useAuthenticationStore(pinia)
import { useEmployeeStore } from './employeeStore.js'
const employeeStore = useEmployeeStore(pinia)

import { globalRouter } from "../routes/globalRouter";

const axiosInstance = axios.create({
  baseURL: envBaseURL,
  withCredentials: true,
  xsrfCookieName: "CSRF-TOKEN",
  xsrfHeaderName: "X-CSRF-Token",
});
// This seems to have replaced withCredentials
axiosInstance.defaults.withXSRFToken = true;

axiosInstance.interceptors.request.use((config) => {
  config.headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...config.headers,
  };
  config.paramsSerializer = params => {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    });
  };
  const fullUrl = `${config.baseURL}${config.url}?${config.paramsSerializer(config.params)}`;
  return config;
});

axiosInstance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.config && error.config.handleLocally) {
    return Promise.reject(error);
  }

  if ((error.response) && (error.response.status === 401)) {
    let ignore_paths = [
      envBaseURL + '/login',
      envBaseURL + '/ping',
      envBaseURL + '/update_password',
      envBaseURL + '/unlock',
    ];
    if (!ignore_paths.includes(error.request.responseURL)) {
      // toast.error('Du har ingen rettigheder til denne ressource og vil blive logget af.' ,{
      //   icon: 'fa fa-times',
      //   timeout: 12000,
      // });
      // APP.$axios.delete('/logout');
      employeeStore.RESET_STATE()
      globalRouter.router?.push("/");
      axios.delete('/logout').catch(() => {});
      employeeStore.RESET_STATE();

      setTimeout(() => {
        window.location.href = '/';
      }, 100);
    }
  } else if ((error.response) && (error.response.status === 403)) {
    toast.error('Du har ingen rettigheder til denne ressource og vil blive logget af.' ,{
      icon: 'fa fa-times',
      timeout: 12000,
    });
    toast.error('Du har ingen rettigheder til denne ressource.', {
      icon: 'fa fa-times',
      timeout: 12000,
    });
  } else if (error.response && error.response.status === 422) {
    toast.error("En eller flere fejl forhindrede opdatering", {
      icon: 'fa fa-times',
      timeout: 45000,
    });
    let response = error.response;
    for (let key in response.data) {
      toast.warning(response.data[key].join('. '), {
        icon: 'fa fa-times',
        timeout: 45000,
      });
    }
  } else if (error.response && error.response.status === 500) {
    let error_messages = 'En fejl på serveren forhindrede forespørgsel, kontakt administrator for at få problemet løst'
    if (error.response?.data?.error) {
      error_messages = `${error_messages}: ${error.response.data.error}`;
    }
    toast.error(error_messages, {
      icon: 'fa fa-times',
      timeout: 12000,
    });
  } else {
    if (error && error.response) {
      let error_messages = 'En fejl på serveren forhindrede forespørgsel, kontakt administrator for at få problemet løst.'
      if (error.response?.data?.error) {
        error_messages = `${error_messages}: ${error.response.data.error}`;
      }
      toast.warning(error_messages, {
        icon: 'fa fa-times',
        timeout: 12000,
      });
    }
  }

  return Promise.reject(error);
});

export default axiosInstance
